import { rgba } from 'polished';
import styled from 'styled-components';
import { combineValues } from '@clds/component-theme';
import { focusVisible } from '@clds/style-utils';
import { toggleTheme, typeVariant } from './theme';
export const ToggleBase = styled.input `
  position: relative;
  width: ${toggleTheme.toggle.width};
  height: ${toggleTheme.toggle.height};
  vertical-align: middle;
  outline: none;
  box-shadow: none;
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  appearance: none;

  &:before,
  &:after {
    content: '';
    display: block;
    transition: 0.2s;
    position: absolute;
    top: 0;
    left: 0;
  }

  &:before {
    width: 100%;
    height: 100%;
    border-radius: ${toggleTheme.toggle.radius};
    background-color: ${typeVariant((branch) => branch.toggle.color.base)};
  }

  &:after {
    width: ${toggleTheme.pill.size};
    height: ${toggleTheme.pill.size};
    border-radius: 100%;
    background-color: ${toggleTheme.pill.color.base};
    top: ${toggleTheme.pill.position.top};
    transform: translate3d(${toggleTheme.pill.position.left.inactive}, 0, 0);
  }

  &:checked {
    &:before {
      background-color: ${typeVariant((branch) => branch.toggle.color.active)};
    }

    &:after {
      transform: translate3d(${toggleTheme.pill.position.left.active}, 0, 0);
    }
  }

  &${focusVisible()} {
    &:before {
      box-shadow: 0 0 0 ${toggleTheme.focus.shadow.size}
        ${combineValues(toggleTheme.focus.color, (color) => rgba(color, 0.5))};
    }

    &:after {
      background-color: ${toggleTheme.pill.color.focus};
    }
  }

  &:disabled {
    &:before {
      background-color: ${combineValues(toggleTheme.toggle.color.disabled, (color) => rgba(color, 0.5))};
    }

    &:after {
      background-color: ${combineValues(toggleTheme.pill.color.disabled, (color) => rgba(color, 0.5))};
    }
  }
`;
//# sourceMappingURL=Toggle.styled.js.map